/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice\src\Services\AttribuedCar\AttribuedCarService.ts
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice
 * Created Date: Wednesday October 16th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday October 16th 2024 10:18:07 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import Config from "Config/Config";
import { buildAxiosHeader } from "Utils/Request.utils";
import Axios from "axios";

export default class AttribuedCarService {
    static getAttribuedCar(offerID: string) {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.ATTRIBUED_CAR}/offer/${offerID}`;
        return Axios.get(myUrl, buildAxiosHeader());
    };

    static createAttribuedCar(offerID: string) {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.ATTRIBUED_CAR}/offer/${offerID}`;
        return Axios.post(myUrl, {}, buildAxiosHeader());
    };

    static getAttribuedCarFiles(attribuedID: string) {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.OFFERFILES}/attribued/${attribuedID}`;
        return Axios.get(myUrl, buildAxiosHeader());
    };

    static update(attribuedID: string, data: {}) {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.ATTRIBUED_CAR}/${attribuedID}`;
        return Axios.put(myUrl, data, buildAxiosHeader());
    };

    static delete(attribuedID: string) {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.ATTRIBUED_CAR}/${attribuedID}`;
        return Axios.delete(myUrl, buildAxiosHeader());
    };
}
